import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import Prices from './Prices/Prices';

const useStyles = makeStyles({
  content: { cursor: 'help' },
});

const PriceAfterDiscountTooltip = ({
  ecoContainerPrice,
  priceAddonsAfterDiscount,
  priceAddonsBeforeDiscount,
  priceAddonsDiscount,
  priceAfterDiscount,
  priceBeforeDiscount,
  priceDeliveryAfterDiscount,
  priceDeliveryBeforeDiscount,
  priceDeliveryDiscount,
  priceDiscount,
  priceDishesAfterDiscount,
  priceDishesBeforeDiscount,
  priceDishesDiscount,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Tooltip
      interactive={true}
      title={
        <div>
          <Prices
            title={t('ecommerceBags.fields.bag.price.diet')}
            prices={[
              {
                name: t('ecommerceBags.fields.bag.price.before'),
                value: priceBeforeDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.discount'),
                value: priceDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.after'),
                value: priceAfterDiscount,
              },
            ]}
          />
          <hr />
          <Prices
            title={t('ecommerceBags.fields.bag.price.delivery')}
            prices={[
              {
                name: t('ecommerceBags.fields.bag.price.before'),
                value: priceDeliveryBeforeDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.discount'),
                value: priceDeliveryDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.after'),
                value: priceDeliveryAfterDiscount,
              },
            ]}
          />
          <hr />
          <Prices
            title={t('ecommerceBags.fields.bag.price.dish')}
            prices={[
              {
                name: t('ecommerceBags.fields.bag.price.before'),
                value: priceDishesBeforeDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.discount'),
                value: priceDishesDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.after'),
                value: priceDishesAfterDiscount,
              },
            ]}
          />
          <hr />
          <Prices
            title={t('ecommerceBags.fields.bag.price.addon')}
            prices={[
              {
                name: t('ecommerceBags.fields.bag.price.before'),
                value: priceAddonsBeforeDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.discount'),
                value: priceAddonsDiscount,
              },
              {
                name: t('ecommerceBags.fields.bag.price.after'),
                value: priceAddonsAfterDiscount,
              },
            ]}
          />
          <hr />
          <Prices
            title={t('ecommerceBags.fields.bag.price.ecoContainer')}
            prices={[
              {
                name: t('ecommerceBags.fields.bag.price.before'),
                value: ecoContainerPrice,
              },
            ]}
          />
        </div>
      }
      placement="right"
    >
      <span className={classes.content}>
        {(
          (priceAfterDiscount || 0) +
          (priceAddonsAfterDiscount || 0) +
          (priceDishesAfterDiscount || 0) +
          (priceDeliveryAfterDiscount || 0)
        )?.toFixed(2) || 0}
      </span>
    </Tooltip>
  );
};

export default PriceAfterDiscountTooltip;
